module.exports = __webpack_public_path__ + "img/inncash-background-webinar-tax-reform.8dcf9cf5.webp";